import { Button, Col, Row } from "antd";
import { Formik, Form } from "formik";
import * as Yup from 'yup';
import SelectInput from "../../components/inputs/SelectInput";
import withRoleProtection from "../../components/withRoleProtection";
import { useCallback, useEffect, useState } from "react";
import { getData, postData } from "../../helpers/api";
import TextInput from "../../components/inputs/TextInput";
import TableLayout from "../../components/layouts/TableLayout";
import moment from "moment";

const ConfirmationPayment = () => {
    const [users, setUsers] = useState([])
    const [userId, setUserId] = useState(null)
    const [data, setData] = useState(null)
    const [paymentHistory, setPaymentHistory] = useState({
        payments: [],
        total: 0
    })
    const getUsers = async () => {
        try {
            const res = await getData('/users/confirmations')
            setUsers(res.data.map((user) => ({ value: user.id, label: user.name })))
        } catch (error) {

        }
    }

    const getPaymentHistory = useCallback(async (page=1, limit=10) => {
        try {
            const res = await getData('/payment/history', { userId, page, limit })
            setPaymentHistory(res.data)
        } catch (error) {

        }
    }, [userId])

    const getpaymentData = useCallback(async () => {
        try {
            const res = await getData('/payment', { userId })
            setData(res.data)
        } catch (error) {

        }
    }, [userId])

    const addPayment = async (payment) => {
        try {
            await postData('/payment', {
                user: parseInt(userId),
                payment,
                totalUnitsUpSell: data.totalUnitsUpSell,
                totalDeliveredOrders: data.totalDeliveredOrders,
                totalUnitsCruSell: data.totalUnitsCruSell,
            })
            getPaymentHistory()
            getpaymentData()
        } catch (error) {

        }
    }
    useEffect(() => {
        getUsers()
    }, [])

    useEffect(() => {
        if (userId) {
            getPaymentHistory()
            getpaymentData()
        }
    }, [getPaymentHistory, getpaymentData, userId])
    const columns = [
        {
            title: "Paiement",
            dataIndex: "payment",
            key: "payment",
        },
        {
            title: "Total Commandes livrees",
            dataIndex: "totalDeliveredOrders",
            key: "totalDeliveredOrders",
        },
        {
            title: "Total UpSell",
            dataIndex: "totalUnitsUpSell",
            key: "totalUnitsUpSell",
        },
        {
            title: "Total Crossel",
            dataIndex: "totalUnitsCruSell",
            key: "totalUnitsCruSell",
        },
        {
            title: "Date de paiement",
            dataIndex: "createdAt",
            key: "createdAt",
            render: (text) => <div>{moment(text).format('YYYY-MM-DD')}</div>
        },
    ]
    return (
        <>
            <Row>
                <Col span={12}>
                    <Formik
                        initialValues={{ userId: null }}
                        validationSchema={Yup.object({
                            userId: Yup.number().required('required'),
                        })}
                        onSubmit={(values, submitProps) => {
                            console.log(values, submitProps)
                            setUserId(values.userId)
                        }}
                    >
                        <Form>
                            <Row>
                                <Col span={24} style={{ textAlign: "left" }}>Selectionner un emplyee</Col>
                                <Col span={6}>
                                    <SelectInput
                                        name="userId"
                                        size="large"
                                        placeholder={"Emplyee"}
                                        options={users}
                                    />
                                </Col>
                                <Col span={4}>
                                    <Button size='large' type="primary" htmlType="submit">
                                        Selectionner
                                    </Button>
                                </Col>
                            </Row>
                        </Form>
                    </Formik>
                </Col>
                {userId && <Col span={12}>
                    <Formik
                        initialValues={{ payment: null }}
                        validationSchema={Yup.object({
                            payment: Yup.number().required('required'),
                        })}
                        onSubmit={(values, submitProps) => {
                            addPayment(values.payment)
                        }}
                    >
                        <Form>
                            <Row>
                                <Col span={24} style={{ textAlign: "left" }}>Ajouter paiement</Col>
                                <Col span={6} >
                                    <TextInput
                                        name="payment"
                                        placeholder="Montant"
                                        size="large"
                                    />
                                </Col>
                                <Col span={4}>
                                    <Button size='large' type="primary" htmlType="submit">
                                        Ajouter
                                    </Button>
                                </Col>
                            </Row>
                        </Form>
                    </Formik>
                </Col>}

            </Row>
            {data && <>
                <Row gutter={[14, 20]}>
                    <Col span={4}>
                        <h2>Paiement par commandes</h2>
                        <h3>{data.paymentPerOrder}</h3>
                    </Col>
                    <Col span={4}>
                        <h2>Paiement UpSell</h2>
                        <h3>{data.paymentPerUpSell}</h3>
                    </Col>
                    <Col span={4}>
                        <h2>total UpSell</h2>
                        <h3>{data.totalUnitsUpSell}</h3>
                    </Col>
                    <Col span={4}>
                        <h2>total Crossel</h2>
                        <h3>{data.totalUnitsCruSell}</h3>
                    </Col>
                    <Col span={4}>
                        <h2>Total des commandes livrées</h2>
                        <h3>{data.totalDeliveredOrders}</h3>
                    </Col>
                    <Col span={4}>
                        <h2>total payé</h2>
                        <h3>{data.totalPayed}</h3>
                    </Col>
                    <Col span={4}>
                        <h2>total à payer</h2>
                        <h3>{data.totalToPay}</h3>
                    </Col>
                    <Col span={4}>
                        <h2>Total paiement Crossel</h2>
                        <h3>{data.totalUnitsCruSellPayment}</h3>
                    </Col>
                    <Col span={4}>
                        <h2>Le reste</h2>
                        <h3>{data.restToPay}</h3>
                    </Col>
                </Row>
                <Row gutter={[14, 20]}>
                    <Col span={4}>
                        <h2>Nouveaur Paiement par commandes</h2>
                        <h3>{data.newPaymentPerOrders}</h3>
                    </Col>
                    <Col span={4}>
                        <h2>Nouveaur Paiement UpSell</h2>
                        <h3>{data.newUpSellOrdersPayment}</h3>
                    </Col>
                    <Col span={4}>
                        <h2>Nouveaur total UpSell</h2>
                        <h3>{data.newUpSellOrders}</h3>
                    </Col>
                    <Col span={4}>
                        <h2>Nouveaur total Crossel</h2>
                        <h3>{data.newCruSellOrders}</h3>
                    </Col>
                    <Col span={4}>
                        <h2>Nouveau Total paiement Crossel</h2>
                        <h3>{data.newCruSellOrdersPayment}</h3>
                    </Col>
                    <Col span={4}>
                        <h2>Nouveau Total des commandes livrées</h2>
                        <h3>{data.newDeliverOrdersCount}</h3>
                    </Col>
                </Row>
            </>}
            <TableLayout
                columns={columns}
                total={paymentHistory.total}
                dataSource={paymentHistory.payments}
                getData={getPaymentHistory}
                displayAddBtn={true}
            />
        </>
    );
}

export default withRoleProtection(ConfirmationPayment, ['super admin']);